import { useMatch } from "react-router-dom";

import {
  COMMAND_LINK_LANDING_RELATIVE_URL,
  CommandLinkName,
} from "../../../constants";
import { Switcher } from "../components/Switcher";
import { MainLayout } from "../layouts";

export function AuthenticationContainer() {
  const commandLinkMatch = useMatch(COMMAND_LINK_LANDING_RELATIVE_URL);

  /**
   * The submit-quote command link is the one unauthenticated route that renders a
   * full shipment card and quote form, so it gets the wide layout. Every other
   * route here is a sign-in sized form and keeps the branding split.
   */
  const isSubmitQuoteLanding =
    commandLinkMatch?.params.commandName === CommandLinkName.SUBMIT_QUOTE;

  return (
    <MainLayout authComponent={<Switcher />} wide={isSubmitQuoteLanding} />
  );
}
